import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'app-info',
	templateUrl: './info.component.html',
	styleUrls: ['./info.component.scss'],
})
export class InfoComponent implements OnInit {
	@Input() event!: string;
	isDescription: boolean = false;
	isOutcomeCompetitor: boolean = false;
	isOutcomeChallenger: boolean = false;
	isDescriptionGuess: boolean = false;
	isChallengerGuess: boolean = false;
	isCompetitorGuess: boolean = false;

	constructor() {}

	ngOnInit() {
		switch (this.event) {
			case 'description':
				this.isDescription = true;
				break;

			case 'outcome_competitor':
				this.isOutcomeCompetitor = true;
				break;

			case 'outcome_challenger':
				this.isOutcomeChallenger = true;
				break;

			case 'challenger_guess':
				this.isChallengerGuess = true;
				break;

			case 'competitor_guess':
				this.isCompetitorGuess = true;
				break;

			case 'description_guess':
				this.isDescriptionGuess = true;
				break;

			default:
				break;
		}
	}
}
